<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			{{ title }}
		</h3>
		<p>
			Faites du bruit autour du sujet pour convaincre vos proches d’agir&nbsp;! Vous pouvez partager cette page via&nbsp;:
		</p>

		<p>
			<a :href="facebook" target="_blank" @click="share($event, 'facebook')" class="share-item">
				<i class="icon-facebook"></i>
				Facebook
			</a>
		</p>
		<p>
			<a :href="twitter" target="_blank" @click="share($event, 'twitter')" class="share-item">
				<i class="icon-twitter"></i>
				Twitter
			</a>
		</p>
		<p>
			<a :href="whatsapp" target="_blank" @click="share($event, 'whatsapp')" class="share-item">
				<i class="icon-whatsapp"></i>
				Whatsapp
			</a>
		</p>

	</div>
</template>

<script>
export default {
	name: "ActionShare",
	props: {
		title: String,
	},
	data() {
		return {
			twitter: process.env.VUE_APP_SHARE_URL_TWITTER,
			facebook: process.env.VUE_APP_SHARE_URL_FACEBOOK,
			whatsapp: process.env.VUE_APP_SHARE_URL_WHATSAPP,
		}
	},
	methods: {
		share(e, label) {
			e.preventDefault()
			let href = e.target.href

			this.$trackEvent("click", "onglet partage " + label)
			window.open(href)
		}
	},
}
</script>